
    export default function scholarshipData($http) {
        return {
            init: function (id) {
                return $http.get('/webapi/scholarshipfilter/get/' + id).then(function (result) {
                    return result.data;
                });
            }
        };
    };
